import { RefinementCtx, z } from 'zod'

import { cvValidator, ICV } from 'validators/new/cv.validator'

const messageErrorForField = [
  'educationHistory',
  'employmentHistory',
  'dateOfBirth',
  'expectedSalaryEuros',
  'contactInformation',
  'languages',
  'employmentStatus'
]

export const checkFieldOnDateValid = (
  value: { startDate: string | null; endDate?: string | null },
  ctx: RefinementCtx,
  canBeSame?: boolean
) => {
  const currentDate = new Date()
  const startDate = value.startDate ? new Date(value.startDate) : ''
  const endDate = value.endDate ? new Date(value.endDate) : ''
  const compare = canBeSame ? startDate > endDate : startDate >= endDate
  if (startDate && endDate && compare) {
    ctx.addIssue({
      path: ['endDate'],
      code: z.ZodIssueCode.custom,
      message: 'custom.endDate'
    })
  }
  if (startDate && startDate > currentDate) {
    ctx.addIssue({
      path: ['startDate'],
      code: z.ZodIssueCode.custom,
      message: 'custom.startDate'
    })
  }
  if (endDate && endDate > currentDate) {
    ctx.addIssue({
      path: ['endDate'],
      code: z.ZodIssueCode.custom,
      message: 'custom.endDateLowerCurrentDate'
    })
  }
}

export const onSubmitCVForm = (
  cv: Partial<ICV>,
  onSubmit: (values: ICV) => void,
  onError: (msg: string) => void
) => {
  const parse = cvValidator.safeParse(cv)
  if (parse.success) {
    onSubmit(parse.data)
  } else {
    const errors: Record<string, string> = parse.error.errors
      .map(({ path }) => {
        const [field] = path
        const [errorField] = path.reverse()
        // Check on error in dictionary and Generate error path
        if (messageErrorForField.includes(field?.toString() ?? '')) {
          return `cvErrors.${field}.${errorField}`
        }

        return ''
      })
      .filter((s) => s)
      // Remove duplicate errors
      .reduce((acc, error) => ({ ...acc, [error.toString()]: error }), {})

    Object.values(errors).forEach((err) => {
      onError(err)
    })
  }
}
